import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Payment\GetPaymentByIdController::__invoke
* @see app/Http/Controllers/Payment/GetPaymentByIdController.php
* @route '/api/invoicing/{invoice}/payment/{payment}'
*/
const GetPaymentByIdController = (args: { invoice: string | number | { id: string | number }, payment: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, payment: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPaymentByIdController.url(args, options),
    method: 'get',
})

GetPaymentByIdController.definition = {
    methods: ["get","head"],
    url: '/api/invoicing/{invoice}/payment/{payment}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Payment\GetPaymentByIdController::__invoke
* @see app/Http/Controllers/Payment/GetPaymentByIdController.php
* @route '/api/invoicing/{invoice}/payment/{payment}'
*/
GetPaymentByIdController.url = (args: { invoice: string | number | { id: string | number }, payment: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, payment: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
            payment: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
        payment: typeof args.payment === 'object'
        ? args.payment.id
        : args.payment,
    }

    return GetPaymentByIdController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace('{payment}', parsedArgs.payment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Payment\GetPaymentByIdController::__invoke
* @see app/Http/Controllers/Payment/GetPaymentByIdController.php
* @route '/api/invoicing/{invoice}/payment/{payment}'
*/
GetPaymentByIdController.get = (args: { invoice: string | number | { id: string | number }, payment: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, payment: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPaymentByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Payment\GetPaymentByIdController::__invoke
* @see app/Http/Controllers/Payment/GetPaymentByIdController.php
* @route '/api/invoicing/{invoice}/payment/{payment}'
*/
GetPaymentByIdController.head = (args: { invoice: string | number | { id: string | number }, payment: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, payment: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPaymentByIdController.url(args, options),
    method: 'head',
})

export default GetPaymentByIdController